import { createFileRoute, Navigate } from "@tanstack/react-router"
import { Workflow } from "modules/campaigns/components/Detail/Workflow"
import { useCampaignQuery } from "modules/campaigns/hooks/useCampaignQuery"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { z } from "zod"

const SearchSchema = PaginationSearchSchema.extend(SearchQuerySchema.shape).extend(
  z.object({
    field: z.enum(["name", "status", "language"]).default("name"),
    order: z.enum(["asc", "desc"]).default("asc"),
  }).shape,
)

export const Route = createFileRoute("/_base/_auth/campaigns/$id/workflows")({
  validateSearch: SearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data: campaign } = useCampaignQuery(id)

  if (campaign?.isLogistics) {
    return <Navigate to="/campaigns/$id/insights" params={{ id }} replace />
  }

  return <Workflow campaignId={id} />
}
